<template>
  <InputComponent v-bind="$attrs" v-model.number="comp" />
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { ValueComp } from '../utils'

export default {
  props: ['value'],
  computed: {
    comp: ValueComp(),
  },
  components: {
    InputComponent,
  },
}
</script>
